import React,{useState} from "react";

function CreateArea(props) {

    var [note , setNote] = useState({
        title: "",
        content: ""
    })

    function handleInputChange(event) {
        var {name , value} = event.target;
        setNote(prevNote => {
            return{
                ...prevNote, [name] : value
            }
        })
    }

    function handleClick(event) {
        props.onAdd(note);
        event.preventDefault();
        
    }

  return (
    <div>
      <form>

        <input
         onChange={handleInputChange}
         name="title" 
         placeholder="Title"
         value={note.title}
        />

        <textarea 
        onChange = {handleInputChange}
        name="content" 
        placeholder="Take a note..." 
        rows="3" 
        value = {note.content} 
        />

        <button 
        onClick = {handleClick}>
        Add
        </button>

      </form>
    </div>
  );
}

export default CreateArea;
